import { showModal, hideModal } from '../helpers/modal.js';

const printSizeDropdown = document.getElementById('printSizeDropdown');
const printDropBtn = document.getElementById('printDropBtn');
const addPrintToCart = document.getElementById('addPrintToCart');
const defaultPrintBtnText = printDropBtn.innerText;

const cardPackageSpecsDiv = document.getElementById('cardPackageSpecs');
const cardPackageSpecs = cardPackageSpecsDiv.getElementsByClassName('package-spec');

const defaultPrice = '$0.00';

document.getElementById('noteCardPrice').innerText = `$${initialTotalPrice}`;


const slider = document.querySelector(".slider-track");

  if (slider) {
    const attachScrollHandler = () => {
      if (slider.scrollWidth > slider.clientWidth) {
        slider.addEventListener(
          "wheel",
          (e) => {
            e.preventDefault();
            slider.scrollLeft += e.deltaY;
          },
          { passive: false }
        );
      }
    };

    // If the content is dynamic, use a MutationObserver to detect changes
    const observer = new MutationObserver(() => {
      attachScrollHandler();
    });

    // Start observing the slider for changes
    observer.observe(slider, { childList: true, subtree: true });

    // Attach the scroll handler initially (if content is already present)
    attachScrollHandler();
  }

// Create an array to store package specs
const cardPackageSpecsArray = [
];

for (let spec of cardPackageSpecs) {
    cardPackageSpecsArray.push({
        id: spec.dataset.id,
        length: spec.dataset.length,
        width: spec.dataset.width,
        height: spec.dataset.height,
        weight: spec.dataset.weight,
        type: spec.dataset.type
    });
}

// Update print price based on selected option
printSizeDropdown.addEventListener('click', function(e) {

    if (e.target.id === 'printSizeReset') {
        resetPrintPrice();
        return
    }
    if (e.target.classList.contains('select-option')) {
        const selectedPrice = e.target.dataset.pi_price;

        // Update the price in the ui
        document.getElementById('selectedPrintPrice').innerText = `$${selectedPrice}`;

        // add selected information to dropdown button
        printDropBtn.innerText = e.target.dataset.pi_size;
        printDropBtn.classList.add('selected');

        // Remove "selected" class from all options
        const options = printSizeDropdown.getElementsByClassName('select-option');
        for (let option of options) {
            option.classList.remove('selected');
        }
        //add selected class to clicked option
        e.target.classList.add('selected');

        addPrintToCart.classList.add('highlight');
    }
});
// Reset print price and dropdown button text
function resetPrintPrice() {
    document.getElementById('selectedPrintPrice').innerText = defaultPrice;
    printDropBtn.innerText = defaultPrintBtnText;
    const options = printSizeDropdown.getElementsByClassName('select-option');
        for (let option of options) {
            option.classList.remove('selected');
        }
    // selectedPrintOption = null;
    addPrintToCart.classList.remove('highlight');

}
// Add print to cart
addPrintToCart.addEventListener('click', function() {
    const selectedPrintOption = document.querySelector('.select-option.selected');
    const quantity = 1;

    if (!selectedPrintOption) {
        showModal('<h4>Please select a print size</h4>');

        const showDropdown = document.querySelector('.dropdown');
        showDropdown.classList.add('show-dropdown');

        // set delay to close dropdown
        setTimeout(() => {
            showDropdown.classList.remove('show-dropdown');
        }, 5000);

        return;
    }
    
    const cartItem = {
        id: selectedPrintOption.dataset.pi_id,
        photos_id: selectedPrintOption.dataset.p_id,
        name: selectedPrintOption.dataset.p_name,
        img: `${selectedPrintOption.dataset.p_img}-print-400.webp`,
        series: selectedPrintOption.dataset.s_series,
        series_id: selectedPrintOption.dataset.s_id,
        quantity: quantity,
        baseCount: 1,
        price: selectedPrintOption.dataset.pi_price,
        unitPrice: selectedPrintOption.dataset.pi_price,
        size: selectedPrintOption.dataset.pi_size,
        orientation: selectedPrintOption.dataset.pi_orientation,
        uiType: `Fine Art Print`,
        type: selectedPrintOption.dataset.type,
        packageSpecs: {
            length: selectedPrintOption.dataset.pi_pkg_length,
            width: selectedPrintOption.dataset.pi_pkg_width,
            height: selectedPrintOption.dataset.pi_pkg_height,
            weight: selectedPrintOption.dataset.pi_pkg_weight,
            pkgType: selectedPrintOption.dataset.pi_pkg_type
        }
    };

    showModal(
        `<h4>You've added an item to the cart!<h4>
        <h3>${selectedPrintOption.dataset.p_name}</h3>
        <p>Fine Art Print<br>
        ${selectedPrintOption.dataset.pi_size}</p>`, {
        confirmCallback: () => {
            window.location.href = '/store/cart';
        },
        cancelCallback: () => {hideModal();},
        yesText: 'Go to Cart',
        noText: 'Continue Shopping'
        });

    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    cart.push(cartItem);
    localStorage.setItem('cart', JSON.stringify(cart));

    updateCartItemCount();
    resetPrintPrice();

});

const addNoteCardToCart = document.getElementById('addNoteCardToCart');
const noteCardQty = document.getElementById('noteCardQty');
const initialPricePerCard = parseFloat(addNoteCardToCart.dataset.ci_price);
const initialQuantity = 0;
const initialTotalPrice = (initialPricePerCard * initialQuantity).toFixed(2);
const noteCardPrice = document.getElementById('noteCardPrice');
const decreaseQtyBtn = document.getElementById('decreaseQty');

// Update the note card price based on the quantity
function updateTotalCardPrice() {
    const totalPrice  = (initialPricePerCard * currentQuantity).toFixed(2);
    noteCardPrice.innerText = `$${totalPrice}`;
}
let currentQuantity = initialQuantity;
noteCardQty.innerText = currentQuantity;

// Increase the note card quantity
document.getElementById('increaseQty').addEventListener('click', function() {

    if (currentQuantity === 0) {
        currentQuantity = 6;
        addNoteCardToCart.classList.add('highlight');
    }
    else {
    currentQuantity++;
    }
    noteCardQty.innerText = currentQuantity;
    updateTotalCardPrice();
    if (currentQuantity >= 6) {
        decreaseQtyBtn.classList.remove('hidden');
    }
});

// Decrease the note card quantity
document.getElementById('decreaseQty').addEventListener('click', function() {
    if (currentQuantity > 6) {
        currentQuantity--;
        noteCardQty.innerText = currentQuantity;
        updateTotalCardPrice();
    } 
    else {
        resetNoteCardPrice();
    }
});
updateTotalCardPrice();

function resetNoteCardPrice() {
    currentQuantity = initialQuantity;
    noteCardQty.innerText = currentQuantity;
    noteCardPrice.innerText = defaultPrice;
    addNoteCardToCart.classList.remove('highlight');
    decreaseQtyBtn.classList.add('hidden');
}
 

addNoteCardToCart.addEventListener('click', function() {

    if (currentQuantity === 0) {
        showModal('<h4>Please select a quantity to add to your cart</h4>');
        return;
    }
    const quantity = currentQuantity;
    const cardWeight = parseFloat(addNoteCardToCart.dataset.ci_weight);
    const totalPrice = (parseFloat(addNoteCardToCart.dataset.ci_price) * quantity).toFixed(2);

    // determine the appropriate package specs based on the card quantity
    let selectedPackage;
    if (quantity <= 12) {
        selectedPackage = cardPackageSpecsArray.find(pkg => pkg.id === '1');
    } else {
        selectedPackage = cardPackageSpecsArray.find(pkg => pkg.id === '2');
    }

    let totalWeight = 0;

    if (selectedPackage) {
        const weightPerCard = parseFloat(cardWeight);
        const packageWeight = parseFloat(selectedPackage.weight);
        totalWeight = (weightPerCard * quantity) + packageWeight;
    } else {
        console.error('No package specs found for the selected quantity');
    }

    const cartItem = {
        id: addNoteCardToCart.dataset.ci_id,
        photos_id: addNoteCardToCart.dataset.p_id,
        name: addNoteCardToCart.dataset.p_name,
        img: `${addNoteCardToCart.dataset.p_img}-card-400.webp`,
        series: addNoteCardToCart.dataset.s_series,
        series_id: addNoteCardToCart.dataset.s_id,
        quantity: quantity,
        baseCount: 1,
        price: totalPrice,
        unitPrice: addNoteCardToCart.dataset.ci_price,
        size: addNoteCardToCart.dataset.ci_card_size,     
        orientation: addNoteCardToCart.dataset.p_orientation,   
        uiType: `Individual Note Cards`,
        type: addNoteCardToCart.dataset.type,
        packageSpecs: {
            length: selectedPackage.length,
            width: selectedPackage.width,
            height: selectedPackage.height,
            weight: totalWeight,
            pkgType: selectedPackage.type
        }
    };

    showModal(
        `<h4>You've added an item to the cart!<h4>
        <h3>${addNoteCardToCart.dataset.p_name}</h3>
        <p>${quantity} Individual Note Cards<br>
        ${addNoteCardToCart.dataset.ci_card_size}</p>`, {
        confirmCallback: () => {
            window.location.href = '/store/cart';
        },
        cancelCallback: () => {hideModal();},
        yesText: 'Go to Cart',
        noText: 'Continue Shopping'
        });

    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    cart.push(cartItem);
    localStorage.setItem('cart', JSON.stringify(cart));

    updateCartItemCount();
    resetNoteCardPrice();

});

const addSeriesCardToCart = document.getElementById('addSeriesCardToCart');
const seriesCount = parseFloat(addSeriesCardToCart.dataset.csi_series_count);
const seriesPrice = parseFloat(addSeriesCardToCart.dataset.csi_price);
const seriesTotalPrice = (seriesCount * seriesPrice).toFixed(2);
const seriesBtn = document.getElementById('seriesBtn');
const defaultSeriesBtnText = seriesBtn.innerText;
const seriesCardPriceUI = document.getElementById('seriesCardPrice');

seriesCardPriceUI.innerText = defaultPrice;

seriesBtn.addEventListener('click', function(e) {

    const isSelected = addSeriesCardToCart.classList.contains('highlight');

    if (isSelected) {
        resetSeriesCardPrice();
        return;
    } else {
        seriesCardPriceUI.innerText = `$${seriesTotalPrice}`;
        addSeriesCardToCart.classList.add('highlight');
        seriesBtn.innerText = 'De-Select this Set';
    }

});
function resetSeriesCardPrice() {
    seriesCardPriceUI.innerText = defaultPrice;
    addSeriesCardToCart.classList.remove('highlight');
    seriesBtn.innerText = defaultSeriesBtnText;
}

addSeriesCardToCart.addEventListener('click', function() {

    if (!addSeriesCardToCart.classList.contains('highlight')) {
        showModal('<h4>Please select the set to add it to your cart</h4>');
        return;
    }
    const cardWeight = parseFloat(addSeriesCardToCart.dataset.csi_card_weight);
    const seriesWeight = (seriesCount * cardWeight).toFixed(2);
    const quantity = 1;

    // Decode the JSON string and replace HTML-encoded entities
    const rawSeriesPhotosJSON = this.dataset.seriesphotos || '[]';
    const decodedSeriesPhotosJSON = rawSeriesPhotosJSON.replace(/&quot;/g, '"'); 

    // determine the appropriate package specs based on the card quantity
    let selectedPackage;
    if (seriesCount <= 12) {
        selectedPackage = cardPackageSpecsArray.find(pkg => pkg.id === '1');
    } else {
        selectedPackage = cardPackageSpecsArray.find(pkg => pkg.id === '2');
    }

    try {

        const seriesPhotos = JSON.parse(decodedSeriesPhotosJSON); // Parse the corrected JSON

    const cartItem = {
        id: addSeriesCardToCart.dataset.csi_id,
        photos_id: addSeriesCardToCart.dataset.p_id,
        name: "Multiple Images",
        img: `${addSeriesCardToCart.dataset.p_img}-card-400.webp`,
        series: addSeriesCardToCart.dataset.s_series,
        series_id: addSeriesCardToCart.dataset.s_id,
        seriesPhotos: seriesPhotos,
        quantity: quantity,
        baseCount: seriesCount,
        price: seriesTotalPrice,
        unitPrice: seriesTotalPrice,
        size: addSeriesCardToCart.dataset.csi_card_size,
        orientation: "Multiple",
        uiType: `Set of ${seriesCount} Series Note Cards`,
        type: addSeriesCardToCart.dataset.type,
        packageSpecs: {
            length: selectedPackage.length,
            width: selectedPackage.width,
            height: selectedPackage.height,
            weight: seriesWeight,
            pkgType: selectedPackage.type
        }
    };

    showModal(
        `<h4>You've added an item to the cart!</h4>
        <p>Set of ${seriesCount} Note Cards for the Series:</p>
        <h3>${addSeriesCardToCart.dataset.s_series}</h3>
        <p>${addNoteCardToCart.dataset.ci_card_size}</p>`, {
        confirmCallback: () => {
            window.location.href = '/store/cart';
        },
        cancelCallback: () => {hideModal();},
        yesText: 'Go to Cart',
        noText: 'Continue Shopping'
        });

    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    cart.push(cartItem);
    localStorage.setItem('cart', JSON.stringify(cart));

    updateCartItemCount();
    resetSeriesCardPrice();

    } catch (error) {
        console.error('Error adding series card to cart:', error);
    }   
});